import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './Products.css';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await api.get('/api/products');
        setProducts(response.data || []);
      } catch (error) {
        setError(
          'Failed to load products: ' +
            (error.response?.data?.message || 'Please try again later')
        );
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const handleProductClick = (product) => {
    setSelectedProduct(product);
  };

  const closeModal = () => {
    setSelectedProduct(null);
  };

  if (loading) {
    return (
      <section className="product-section">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Discovering premium products...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="product-section">
      <div className="product-container">
        <div className="header-section">
          <h2 className="main-title">Premium Collection</h2>
          <p className="main-subtitle">
            Discover products crafted with excellence and innovation
          </p>
        </div>

        {error && (
          <div className="error-alert">
            <i className="error-icon">⚠️</i>
            {error}
          </div>
        )}

        <div className="products-grid">
          {products.length > 0 ? (
            products.map((product, index) => (
              <div
                key={product.id}
                className="product-card"
                style={{ animationDelay: `${index * 0.1}s` }}
                onClick={() => handleProductClick(product)}
              >
                <div className="product-image-container">
                  <img
                    src={`http://localhost:8080/api/product/${product.id}/image`}
                    alt={product.name}
                    className="product-image"
                    onError={(e) =>
                      (e.target.src =
                        'https://via.placeholder.com/400x300/f0f0f0/888888?text=Product+Image')
                    }
                  />
                  <div
                    className={`stock-badge ${
                      product.stockQuantity > 0 ? 'in-stock' : 'out-of-stock'
                    }`}
                  >
                    {product.stockQuantity > 0
                      ? '✓ Available'
                      : '✗ Unavailable'}
                  </div>
                  <div className="hover-overlay">
                    <span className="view-details">View Details</span>
                  </div>
                </div>
                <div className="product-content">
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-description">{product.description}</p>
                  <div className="product-footer">
                    <span className="product-price">
                      ${product.price ? product.price.toFixed(2) : '0.00'}
                    </span>
                    {product.stockQuantity > 0 && (
                      <span className="stock-quantity">
                        {product.stockQuantity} left
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            !error && (
              <div className="empty-state">
                <div className="empty-icon">📦</div>
                <h3 className="empty-title">No Products Available</h3>
                <p className="empty-description">
                  Check back soon for exciting new additions!
                </p>
              </div>
            )
          )}
        </div>
      </div>

      {/* Product Detail Modal */}
      {selectedProduct && (
        <div className="modal-overlay" onClick={closeModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="modal-close" onClick={closeModal}>
              ×
            </button>
            <div className="modal-body">
              <div className="modal-image-section">
                <img
                  src={`http://localhost:8080/api/product/${selectedProduct.id}/image`}
                  alt={selectedProduct.name}
                  className="modal-product-image"
                  onError={(e) =>
                    (e.target.src =
                      'https://via.placeholder.com/500x400/f0f0f0/888888?text=Product+Image')
                  }
                />
              </div>
              <div className="modal-info-section">
                <h2 className="modal-product-name">
                  {selectedProduct.name}
                </h2>
                <p className="modal-product-description">
                  {selectedProduct.description}
                </p>

                <div className="modal-details">
                  <div className="detail-item">
                    <span className="detail-label">Price:</span>
                    <span className="detail-value price">
                      $
                      {selectedProduct.price
                        ? selectedProduct.price.toFixed(2)
                        : '0.00'}
                    </span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Stock:</span>
                    <span
                      className={`detail-value ${
                        selectedProduct.stockQuantity > 0
                          ? 'in-stock'
                          : 'out-of-stock'
                      }`}
                    >
                      {selectedProduct.stockQuantity > 0
                        ? `${selectedProduct.stockQuantity} available`
                        : 'Out of stock'}
                    </span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Status:</span>
                    <span
                      className={`status-badge ${
                        selectedProduct.stockQuantity > 0
                          ? 'available'
                          : 'unavailable'
                      }`}
                    >
                      {selectedProduct.stockQuantity > 0
                        ? 'Available'
                        : 'Unavailable'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> 
      )}
    </section>
  );
};

export default Products;
